module.exports = __webpack_public_path__ + "img/X.f14fd637.svg";